import { Injectable } from '@angular/core';
import { BonusContinuaStore } from './bonus-continua.store';
import { Observable } from 'rxjs';
import { Sort } from '@angular/material/sort';
import { VwLabBonusContinua } from 'src/app/models/vwLabBonusContinua';
import { TableObject } from 'src/app/models/tableObject';
import { VwLabBonusContinuaGuest } from 'src/app/models/VwLabBonusContinuaGuest';
import { HttpClient } from '@angular/common/http';
import { ConstantsStore } from '../constants.store';

@Injectable({
  providedIn: 'root'
})
export class BonusContinuaService {

  constructor(
    private store: BonusContinuaStore,
    private http: HttpClient,
    private urlsStore: ConstantsStore
  ) { }

  //#region User Area
  get(pageNumber: number = 1, pageSize: number = 20, filter: string = null, ascending: boolean = null): Observable<any> {
    return new Observable(observer => {
      this.httpGet(pageNumber, pageSize, filter, ascending)
        .subscribe(
          (res: TableObject<VwLabBonusContinua>) => {
            this.store.totalRecords = res.totalRecords;
            this.store.load(res.records);
            observer.next(res.records);
          },
          error => observer.error(error)
        );
    });
  }



  sorting(sort: Sort) {
    const data = this.store.records.slice();

    if (!sort.active || sort.direction === '') {
      this.store.sortedRecords = data;
      return;
    }

    this.store.sortedRecords = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'Isin': return this.compare(a.isin, b.isin, isAsc);
        case 'Emittente': return this.compare(a.emittente, b.emittente, isAsc);
        case 'Nome': return this.compare(a.nome, b.nome, isAsc);
        case 'Sottostante': return this.compare(a.sottostante, b.sottostante, isAsc);
        case 'Scadenza': return this.compare(a.scadenza, b.scadenza, isAsc);
        case 'Barriera': return this.compare(a.barriera, b.barriera, isAsc);
        case 'Buffer': return this.compare(a.buffer, b.buffer, isAsc);
        case 'Bonus': return this.compare(a.bonus, b.bonus, isAsc);
        case 'Cap': return this.compare(a.cap, b.cap, isAsc);
        case 'Prezzo Sott.': return this.compare(a.prezzosott, b.prezzosott, isAsc);
        case 'Prezzo Cert.': return this.compare(a.prezzocert, b.prezzocert, isAsc);
        case 'Upside': return this.compare(a.upside, b.upside, isAsc);
        case 'CedProb': return this.compare(a.cedprob, b.cedprob, isAsc);
        default: return 0;
      }
    });
  }
  //#endregion

  //#region Guest Area
  getGuest(): Observable<any> {
    return new Observable(observer => {
      this.httpGetGuest()
        .subscribe(
          (res: VwLabBonusContinuaGuest[]) => {
            this.store.loadGuest(res);
            observer.next(res);
          },
          error => observer.error(error)
        );
    });
  }

  sortingGuestRecords(sort: Sort) {
    const data = this.store.recordsGuest.slice();

    if (!sort.active || sort.direction === '') {
      this.store.sortedRecordsGuest = data;
      return;
    }

    this.store.sortedRecordsGuest = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'Isin': return this.compare(a.isin, b.isin, isAsc);
        case 'Emittente': return this.compare(a.emittente, b.emittente, isAsc);
        case 'Nome': return this.compare(a.nome, b.nome, isAsc);
        case 'Sottostante': return this.compare(a.sottostante, b.sottostante, isAsc);
        case 'Scadenza': return this.compare(a.scadenza, b.scadenza, isAsc);
        case 'Barriera': return this.compare(a.barriera, b.barriera, isAsc);
        case 'Buffer': return this.compare(a.buffer, b.buffer, isAsc);
        case 'Bonus': return this.compare(a.bonus, b.bonus, isAsc);
        case 'Cap': return this.compare(a.cap, b.cap, isAsc);
        case 'Prezzosott': return this.compare(a.prezzosott, b.prezzosott, isAsc);
        case 'Prezzocert': return this.compare(a.prezzocert, b.prezzocert, isAsc);
        case 'Upside': return this.compare(a.upside, b.upside, isAsc);
        case 'CedProb': return this.compare(a.cedprob, b.cedprob, isAsc);
        default: return 0;
      }
    });
  }
  //#endregion

  compare(a: number | string | Date, b: number | string | Date, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  downloadExcel(pageSize: number) {
    const bonusContinuaDownloadExcelUrl = `${this.urlsStore.bonusContinuaUrl}download/${pageSize}`;
    return this.http.post(bonusContinuaDownloadExcelUrl, null, {responseType: 'blob'}).toPromise();
  }

  private httpGet(
    pageNumber: number,
    pageSize: number,
    filter: string,
    ascending: boolean
  ): Observable<TableObject<VwLabBonusContinua>> {
    const bonusContinuaUrl = `${this.urlsStore.bonusContinuaUrl}${pageNumber}/${pageSize}${this.urlsStore.filterAndAscendingQueryString(filter, ascending)}`;
    return this.http.get<TableObject<VwLabBonusContinua>>(bonusContinuaUrl);
  }

  private httpGetGuest(): Observable<VwLabBonusContinuaGuest[]> {
    return this.http.get<VwLabBonusContinuaGuest[]>(this.urlsStore.bonusContinuaUrl);
  }

}
